// MintNest — the settled mint cube mark that anchors the start of the
// Latently section. It is a plain wrapper around CubeGlyph: on its own it
// renders fully visible and settled (no JS, no observers). The choreography
// module (src/motion/markChoreography.ts) finds it by its data-mark
// attribute and plays a one-shot settle animation the first time the
// Latently section scrolls into view; this component never animates itself.
// Mounted by MeetLatently.tsx, before the "Live · in alpha" livetag text.
import { CubeGlyph } from './CubeGlyph';
import './MintNest.css';

export function MintNest(): JSX.Element {
  return (
    <span className="mark-nest" data-mark="mint-nest" data-seam-anchor="latently-start">
      <CubeGlyph tone="mint" size={48} />
    </span>
  );
}
